import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";

const ViewProviderInterpreterService = ({ office }) => {
  const { t } = useTranslation();

  return (
    office?.interpreterService !== null &&
    office?.interpreterService !== undefined &&
    office?.interpreterService !== "" && (
      <div>
        {office?.interpreterService == "N" && (
          <span className="details-subheader">{t(`interpreterServices`)} </span>
        )}
        {office?.interpreterService == "N" && (
          <span style={{ color: "#000" }}> {t(`no`)}</span>
        )}

        {office?.interpreterService == "Y" && (
          <span className="details-subheader">{t(`interpreterServices`)} </span>
        )}
        {office?.interpreterService == "Y" && (
          <span style={{ color: "#000" }}> {t(`yes`)}</span>
        )}
      </div>
    )
  );
};

ViewProviderInterpreterService.propTypes = {
  office: PropTypes.object,
};

export default ViewProviderInterpreterService;
